import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import Routes from './Routes';
import Header from '../components/Header';
import { getAdvertiser } from '../actions/advertiserActions';
import { getOrder } from '../actions/orderActions';
import { getPlacement } from '../actions/placementActions';
import { setCurrentUser } from '../tracking';
import { getConstants } from "../actions/constantActions";

class Main extends Component {

  navigateTo = async (target) => {
    const { dispatch, history, constants } = this.props;
    if (!target) {
      return;
    }
    if (isEmpty(constants)) {
      await dispatch(getConstants());
    }
    switch(target.entityType) {
      case 'lineitem':
        await dispatch(getAdvertiser(target.advertiserId));
        await dispatch(getOrder(target.ioId));
        await dispatch(getPlacement(target.placementId));
        history.push(`/ios/${target.ioId}/placement/${target.placementId}`);
        break;
      case 'placement':
        await dispatch(getAdvertiser(target.advertiserId));
        await dispatch(getOrder(target.ioId));
        await dispatch(getPlacement(target.id));
        history.push(`/ios/${target.ioId}/placement/${target.id}`);
        break;
      case 'io':
        dispatch(getAdvertiser(target.advertiserId));
        await dispatch(getOrder(target.id));
        history.push(`/ios/${target.id}`);
        break;
      case 'advertiser':
        dispatch(getAdvertiser(target.id));
        history.push(`/advertiser/${target.id}`);
        break;
      default:
        break;
    }    
  };

  render() {
    const { userInfo, placement, order, advertiser, constants } = this.props;
    return (
      <div>
        <Header
          userInfo={userInfo}
          placement={placement}
          order={order}
          advertiser={advertiser}
          constants={constants}
          onSearchbarSelect={this.navigateTo}
        />
        <Routes />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const {
    user,
    orderRequest,
    placementRequest,
    advertiserRequest,
    constantRequest
  } = state;

  setCurrentUser(user.email);

  return {
    userInfo: {
      name: user.displayName,
      email: user.email,
      picture: user.profileImageURL,
      role: user.roleName
    },
    order: orderRequest.order,
    placement: placementRequest.placement,
    advertiser: advertiserRequest.advertiser,
    constants: constantRequest.constants
  }
};

export default withRouter(connect(mapStateToProps)(Main));
